import { CheckboxStyled } from "./styled";

export const Checkbox = ({ checked, onChange, ...props }) => {
  return (
    <CheckboxStyled
      checked={checked}
      onChange={onChange}
      $customStyles={props.style || {}}
      {...props}
    />
  );
};
